import React from 'react';
import type { SessionScreen } from '../../../features/flow/session';
import { cleanParagraph, cleanTitle } from '../../../features/flow/utils';

/**
 * "E-file with IRS (MeF)" screen (US): this step has a bespoke design, but all content comes
 * from `sessionScreen.paragraphs`.
 */
export function IrsMefEfileScreenBody({
  sessionScreen,
  agreed,
  onToggleAgreed,
}: {
  sessionScreen: SessionScreen;
  agreed: boolean;
  onToggleAgreed: () => void;
}) {
  const title = cleanTitle(sessionScreen.title ?? '');

  const cleanedParagraphs = (sessionScreen.paragraphs ?? [])
    .map((p) => cleanParagraph(String(p)))
    .map((p) => p.trim())
    .filter(Boolean)
    // The raw extraction includes a navigation row like "Back ... Continue".
    .filter((p) => !/^Back\\b.*\\bContinue$/i.test(p))
    .filter((p) => !/^Back$/i.test(p) && !/^Continue$/i.test(p));

  // Remove the title repetition paragraph ("Welcome & Setup E-file with IRS (MeF)").
  const contentParagraphs = cleanedParagraphs.filter((p) => !p.includes(title));

  // Raw paragraphs split the locked text into multiple lines and the checkbox label into
  // the single "I authorize ..." sentence.
  const warningParts: string[] = [];
  let consentText = '';
  for (const p of contentParagraphs) {
    if (/^I authorize/i.test(p)) {
      consentText = p;
    } else {
      warningParts.push(p);
    }
  }
  const warningText = warningParts.join(' ').replace(/\s+/g, ' ').trim();

  return (
    <div className="w-full flex flex-col items-start gap-10">
      <div className="w-full flex items-start gap-3">
        <p className="text-base text-[#525353]">🔒 {warningText}</p>
      </div>

      <div className="w-full flex items-start gap-3">
        <input
          type="checkbox"
          checked={agreed}
          onChange={onToggleAgreed}
          className="mt-[2px] h-4 w-4 shrink-0 accent-[#07A2A0]"
          aria-label="Authorized"
        />
        <p className="text-sm text-[#131315] leading-6">{consentText}</p>
      </div>
    </div>
  );
}
